import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'
import { replace } from 'react-router-redux'

import { loadServicingsForWorkOrder } from '../../actions/servicings'

import WorkSummaryWorkOrderTabsSignedOff from '../../components/work-summaries/work-summary-work-order-tabs-signed-off'

const tabNames = [
  'summary',
  'work-details',
  'comments',
  'messages',
]

function mapStateToProps (state, ownProps) {
  const workOrderId = ownProps.workOrderId

  const workOrder = state.workOrders[workOrderId]

  const pagination = get(state, `pagination.servicingsByWorkOrder.${workOrder.id}-finished${workOrder.showInputted ? '_with_deleted' : ''}`, {})
  const servicings = at(state.servicings, pagination.ids || [])

  const selectedTab = tabNames.indexOf(ownProps.location.query.tab)

  return {
    workOrder,
    workOrderId: ownProps.workOrderId,
    servicings,

    selectedTab,

    hasNextPage: !!pagination.nextPageUrl,

    loadingServicings: state.servicings.loading || false
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.workOrderId

  dispatch(loadServicingsForWorkOrder(id, 'finished'))

  return {
    onTabSelect (tabIndex) {
      dispatch(replace({
        pathname: ownProps.location.pathname,
        query: {
          ...ownProps.location.query,
          tab: tabNames[tabIndex]
        }
      }))
    },

    onLoadNextPage () {
      dispatch(loadServicingsForWorkOrder(id, 'finished', true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkSummaryWorkOrderTabsSignedOff)



// WEBPACK FOOTER //
// ./src/containers/work-summaries/work-summary-work-order-tabs-signed-off-container.js